import React from 'react';
import { useTranslation } from 'react-i18next';
import { UploadPreviewColumn } from '@/types/upload';

interface UploadSampleTableProps {
  columns: UploadPreviewColumn[];
  /** The columns that hold the places, marked with what they are (longitude, latitude, WKT). */
  marks: Map<number, string>;
}

/**
 * The first values of a sheet as they are in the file, the place columns marked, so the person can check the choice
 * against real values.
 */
const UploadSampleTable: React.FC<UploadSampleTableProps> = ({ columns, marks }) => {
  const { t } = useTranslation();
  const rows = Math.max(0, ...columns.map((c) => c.sample.length));
  return (
    <div className="overflow-x-auto border border-gn-light rounded-lg max-h-56">
      <table className="w-full text-xs">
        <thead className="bg-gn-primary border-b border-gn-light sticky top-0">
          <tr>
            {columns.map((c) => {
              const mark = marks.get(c.position);
              return (
                <th key={c.position} className={`px-2 py-1.5 text-left align-bottom font-medium text-gn-secondary ${mark ? 'bg-gn-blue-light' : ''}`}>
                  {mark && <span className="block text-[10px] font-semibold text-gn-blue whitespace-nowrap">{mark}</span>}
                  <span className="block max-w-[12rem] truncate" title={c.header}>{c.header || t('uploads.column_n', { n: c.position + 1 })}</span>
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {rows === 0 ? (
            <tr>
              <td colSpan={Math.max(1, columns.length)} className="px-2 py-4 text-center text-gn-secondary">{t('uploads.no_rows')}</td>
            </tr>
          ) : (
            Array.from({ length: rows }, (_, r) => (
              <tr key={r} className="border-b border-gn-light last:border-b-0">
                {columns.map((c) => {
                  const v = c.sample[r] ?? null;
                  return (
                    <td key={c.position} className={`px-2 py-1 text-gn-primary ${marks.has(c.position) ? 'bg-gn-blue-light' : ''}`}>
                      <span className="block max-w-[12rem] truncate" title={v ?? undefined}>{v}</span>
                    </td>
                  );
                })}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default UploadSampleTable;
